import { render, staticRenderFns } from "./StudentProgressTable.vue?vue&type=template&id=dbc240c2&scoped=true"
import script from "./StudentProgressTable.vue?vue&type=script&lang=js"
export * from "./StudentProgressTable.vue?vue&type=script&lang=js"
import style0 from "./StudentProgressTable.vue?vue&type=style&index=0&id=dbc240c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbc240c2",
  null
  
)

export default component.exports